import React from "react";
import PropTypes from 'prop-types';
import Wrapper from "../Wrapper/Wrapper"
import { withAITracking } from 'react-appinsights';

const JournalObjectives = (props) => {

  return(
    <div className="my-4">
      <p className="text-right mb-2 fontSize500">{props.results.date}</p>
      <div className="accordion" id={`accordionExample${props.index}`}>

        {/* Renders collapsible element for each objectives of the entry */}
        {props.results.objectifs.map(function(object, i){
          return <Wrapper key={i}>
                    <div className="card mb-2">
                      <div className="card-header p-0" id={`heading${props.index}${i}`}>
                        <button className="btn btn-link collapsed w-100 mb-0 p-2 px-3" data-toggle="collapse" data-target={`#collapse${props.index}${i}`} aria-expanded={`${(i === 0) ? true : false}`} aria-controls={`collapse${props.index}${i}`}>
                          <p className="m-0 float-left">Objectif {i+1}</p>
                          <span className="purpleColor fas fa-chevron-down float-right p-1"></span>
                        </button>
                      </div>
                      <div id={`collapse${props.index}${i}`} className={`collapse ${(i === 0) ? "show" : ""}`} aria-labelledby={`heading${props.index}${i}`} data-parent={`#accordionExample${props.index}`}>
                        <div className="card-body pt-0 pb-3 px-3">
                          {props.results.objectifs[i]}
                        </div>
                      </div>
                    </div>
                 </Wrapper>
        })}

      </div>
    </div>
  )
}

JournalObjectives.propTypes = {
  results: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default withAITracking(JournalObjectives);
